import { TFiltersData } from '../../models';

export const DEFAULT_FILTERS: TFiltersData = {
  shops: [],
  specializations: [],
  c2cActivated: false,
  isSurgeryClinic: false,
};

export const DEFAULT_FILTERS_EXTERNAL: TFiltersData = {
  ...DEFAULT_FILTERS,
  services: null,
};
